var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": "Wiki Editor Name", role: "dialog" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [_vm._v("Wiki Editing")]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-sm-12" },
          [
            _c("alert", { attrs: { type: "info" } }, [
              _vm._v(
                "\n               If somebody is supporting you to edit this Wiki, please confirm who is helping\n           "
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "div",
            [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  autocomplete: "off",
                  id: "input-fn",
                  type: "text",
                  placeholder:
                    "Someone from my Circle is helping me (select user)",
                },
              }),
              _vm._v(" "),
              _c("typeahead", {
                staticClass: "user-selector-input",
                attrs: {
                  target: "#input-fn",
                  data: _vm.fullNameCircleMembers,
                  "item-key": "fullName",
                },
                model: {
                  value: _vm.wikiEditor,
                  callback: function ($$v) {
                    _vm.wikiEditor = $$v
                  },
                  expression: "wikiEditor",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row margin-15-top" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.wikiEditorName,
                  expression: "wikiEditorName",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: "fullname",
                type: "text",
                placeholder:
                  "Someone else is helping me (add the person’s full name here)",
                disabled: !!_vm.wikiEditorId,
                autocomplete: "name",
              },
              domProps: { value: _vm.wikiEditorName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.wikiEditorName = $event.target.value
                },
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row margin-15-top" }, [
        _c("div", { staticClass: "col-sm-12" }, [
          _c(
            "div",
            [
              _c(
                "btn",
                {
                  staticClass: "current-user-button",
                  attrs: {
                    block: "",
                    size: "lg",
                    type: "primary",
                    disabled: !!_vm.wikiEditorName,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.chooseCurrentUser()
                    },
                  },
                },
                [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: { src: _vm.avatarUrl, alt: "User avatar" },
                  }),
                  _vm._v(
                    "\n                    No, it’s just me doing it on my own (" +
                      _vm._s(_vm.userReadableName) +
                      ")\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-mm btn-green",
            attrs: { disabled: !_vm.wikiEditorId && !_vm.wikiEditorName },
            on: { click: _vm.saveChanges },
          },
          [_vm._v("\n            Continue editing\n        ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }